<template>
    <div>
      <head-top :navActive="navActive"></head-top>
      <!-- 内容 start -->
      <div class="ts-paper-revision">
        <div class="ts-paper-revision-main">
          <div>
            <h2 class="ts-paper-revision-title">你离毕业只差这一步！</h2>
            <p class="ts-paper-revision-en">THE BEST CHOICE OF THE PAPER SEARCH IN THE REPETITION RATE</p>
            <div class="ts-paper-revision-main-list">
              <p class="ts-paper-revision-main-list-item"><i></i><span>我们提供毕业论文、期刊论文、硕、博研究生论文、会议论文降低重复率，润色，格式修改等服务。</span></p>
              <p class="ts-paper-revision-main-list-item"><i></i><span>6年来，已经帮助数千位学子解决论文抄袭率，论文格式，论文重复率高等难题！</span></p>
              <p class="ts-paper-revision-main-list-item"><i></i><span>强大的一手老师资源，首创安全保密修改流程，充分保障客户，隐私和利益！</span></p>
            </div>
            <div class="ts-paper-revision-btn">
              <a id="service" style="cursor: pointer;">
                <i><img src="../../static/img/ts-img/paper-revision-icon1.png" width="22"></i>
                <span>论文修改咨询</span>
              </a>
              <router-link :to="{ path:'/chSystem/'}">
                <i><img src="../../static/img/ts-img/paper-revision-icon2.png" width="22"></i>
                <span>论文查重优惠入口</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容 end -->
      <foot-bottom></foot-bottom>
    </div>
</template>

<script>
  import headTop from '../components/header/head-top'
  import footBottom from '../components/footer/foot-bottom'
    export default {
        name: "paper-revision",
        data () {
          return {
            navActive:6
          }
        },
        components: {
          headTop,
          footBottom,
        }
    }
</script>

<style scoped lang="scss">
  @import "../assets/style/common";
  .ts-paper-revision{
    width: 100%;
    height: 690px;
    background: url("../../static/img/ts-img/paper-revision-bg.png") no-repeat center center;
    .ts-paper-revision-main{
      width: $box-width;
      height: 690px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .ts-paper-revision-title{
        @include font(46px,#333)
      }
      .ts-paper-revision-en{
        @include font(24px,#666);
        margin-bottom: 65px;
      }
      .ts-paper-revision-main-list{
        .ts-paper-revision-main-list-item{
          display: flex;
          align-items: center;
          line-height: 46px;
          i{
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: #3b6bda;
            margin-right: 10px;
          }
          span{
            @include font(20px,#333);
          }
        }
      }
      .ts-paper-revision-btn{
        width: 665px;
        height: 62px;
        @include flex;
        margin-top: 65px;
        a{
          width: 257px;
          height: 62px;
          @include flex($content:center);
          border-radius: 10px;
          span{
            @include font(22px,#fff);
            margin-left: 8px;
          }
          &:first-child{
            background-color: #3b6bda;
          }
          &:last-child{
            background-color: #eb5d71;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/paper-revision.vue